import React from 'react';
import { Bar } from 'react-chartjs-2';

function UserTimeAmountChart({ userTimeMap, label1, label2, labelX, labelY }) {
    const labels = Object.keys(userTimeMap).sort(); // Get sorted usernames
    const timeData = labels.map(username => userTimeMap[username].totalMinutes / 60); // Time in hours
    const amountData = labels.map(username => userTimeMap[username].totalPrice);

    const data = {
        labels,
        datasets: [
            {
                label: label1 ,
                data: timeData,
                backgroundColor: 'rgba(75, 192, 192, 0.8)',  // Adjust opacity
                borderColor: 'white',
                borderWidth: 1,
                fontFamily: "Montserrat",
                borderRadius: 5,  // Rounded corners
                hoverBackgroundColor: 'rgba(75, 192, 192, 0.6)',
                hoverBorderColor: 'rgba(75, 192, 192, 1)'
            },
            {
                label: label2,
                data: amountData,
                backgroundColor: 'rgb(53, 54, 94)',
                borderColor: 'white',
                borderWidth: 2,
                fontFamily: "Montserrat",
                borderRadius: 5,
                hoverBackgroundColor: 'rgba(153, 102, 255, 0.6)',
                hoverBorderColor: 'rgba(153, 102, 255, 1)'
            }
        ]
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    font: {
                        size: 14,  // Increase font size
                        family: 'Montserrat'
                    },
                    color: '#333'  // Legend color
                }
            },
            tooltip: {
                backgroundColor: 'rgba(0, 0, 0, 0.7)', // Dark tooltip background
                titleFont: {
                    size: 16,
                    family: 'Montserrat'
                },
                bodyFont: {
                    size: 14,
                    family: 'Montserrat'
                }
            }
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: labelX,
                    font: {
                        size: 16,
                        weight: 'bold',
                        family: 'Montserrat'
                    },
                    color: '#444'  // Axis title color
                },
                ticks: {
                    font: {
                        size: 14,
                        family: 'Montserrat'
                    },
                    color: '#666'  // X-axis label color
                },
                grid: {
                    display: false  // Disable vertical grid lines
                }
            },
            y: {
                title: {
                    display: true,
                    text: labelY,
                    font: {
                        size: 16,
                        weight: 'bold',
                        family: 'Montserrat'
                    },
                    color: '#444'  // Axis title color
                },
                ticks: {
                    font: {
                        size: 14,
                        family: 'Montserrat'
                    },
                    color: '#666'  // Y-axis label color
                },
                beginAtZero: true
            }
        }
    };


    return <Bar data={data} options={options} />;
}

export default UserTimeAmountChart;
